import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Services from './pages/Services';
import ServicesInfos from './pages/ServicesInfos';
import About from './pages/About';
import Contacts from './pages/Contacts';
import Teams from './pages/Teams';


function App() {
  return (
        <BrowserRouter> 
        
          
           <Routes>
             <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/Services-Infos/:services" element={<ServicesInfos />} />
              <Route path="/contact" element={<Contacts />} />
              <Route path="/Team" element={<Teams />} />
           </Routes>
         </BrowserRouter>
  );
}

export default App;
